import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SkeletonLoaderModule } from 'src/app/shared/components/skeleton-loader/skeleton-loader.module';

@Component({
  selector: 'app-auto-accept-banners-item-skeleton',
  templateUrl: 'auto-accept-banners-item-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SkeletonLoaderModule
  ],
})
export class AutoAcceptBannersItemSkeletonComponent {
  @Input()
  public hasBorder: boolean;
}
